import { Color } from '@diritto/common/style/color';
import styled from '@emotion/styled';
import { RadioSelectedIcon } from 'icons/RadioSelectedIcon';
import { ChangeEvent } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { FontWeight, Typography } from '@diritto/common/style/typography';

type RadioButtonProps<V extends number | string> = {
  name: string;
  showName?: boolean;
  id: string;
  color?: string;
  checked?: boolean;
  className?: string;
  value?: V;
  selectedValue?: V;
  onChange?: (value: ChangeEvent<HTMLInputElement>) => void;
};

const RadioSelectedIconString = encodeURIComponent(renderToStaticMarkup(<RadioSelectedIcon />));

export const RadioButton = <V extends number | string>({
  className,
  name,
  showName = true,
  color = Color.Primary500,
  id,
  value,
  selectedValue,
  checked = false,
  onChange,
}: RadioButtonProps<V>) => (
  <StyledWrapper className={className}>
    <StyledButton
      type="radio"
      id={name}
      name={id}
      value={value}
      checked={checked || selectedValue === value}
      onChange={onChange}
    />
    <Label htmlFor={name} color={color}>
      {showName && <p>{name}</p>}
    </Label>
  </StyledWrapper>
);

const StyledWrapper = styled.div`
  height: 24px;
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;

  ${Typography.XSmall};
  font-weight: ${FontWeight.Regular};

  &:before {
    content: '';
    box-sizing: border-box;
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 20px;
    background: white;
    border: 1px solid ${Color.Gray400};
  }

  & p {
    margin-left: 8px;
  }
`;

const StyledButton = styled.input`
  display: none;

  &:checked + ${Label}:before {
    border: initial;
    background: center url('data:image/svg+xml,${RadioSelectedIconString}') no-repeat;
  }
`;
